/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Initialize_CommunityInputs */

const en_initialize_community = /** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Initialize community portal`)
};

const id_initialize_community = /** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inisialisasi portal komunitas`)
};

/** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */
const es_initialize_community = en_initialize_community;

/** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */
const fr_initialize_community = en_initialize_community;

/** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */
const de_initialize_community = en_initialize_community;

/** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */
const ja_initialize_community = en_initialize_community;

/** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */
const zh_initialize_community = en_initialize_community;

/** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */
const ar_initialize_community = en_initialize_community;

/** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */
const it_initialize_community = en_initialize_community;

/** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */
const ru_initialize_community = en_initialize_community;

/** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */
const pt_initialize_community = en_initialize_community;

/** @type {(inputs: Initialize_CommunityInputs) => LocalizedString} */
const ko_initialize_community = en_initialize_community;

/**
* | output |
* | --- |
* | "Initialize community portal" |
*
* @param {Initialize_CommunityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const initialize_community = /** @type {((inputs?: Initialize_CommunityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Initialize_CommunityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_initialize_community(inputs)
	if (locale === "es") return es_initialize_community(inputs)
	if (locale === "fr") return fr_initialize_community(inputs)
	if (locale === "de") return de_initialize_community(inputs)
	if (locale === "ja") return ja_initialize_community(inputs)
	if (locale === "zh") return zh_initialize_community(inputs)
	if (locale === "ar") return ar_initialize_community(inputs)
	if (locale === "id") return id_initialize_community(inputs)
	if (locale === "it") return it_initialize_community(inputs)
	if (locale === "ru") return ru_initialize_community(inputs)
	if (locale === "pt") return pt_initialize_community(inputs)
	return ko_initialize_community(inputs)
});